<template>
  <div class="title">
    <div class="main">
      {{title.main}}
    </div>
    <div class="sub">
      {{title.sub}}
    </div>
  </div>
</template>

<script>
 export default {
   name: 'FPTitle',
   props: [ 'title'],
   computed: {
   }
 }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
 .title {
   color: #141413;
   display: flex;
   flex-direction: column;
   justify-content: space-between;
   align-items: center;
   margin-top:10.42vw;
 }
 .title .main{
   font-size: 3.27vw;
   letter-spacing: 0.208vw;
   font-family: "Noto Sans SC", SourceHanSansCN-Bold;
   font-weight:bold;
 }
 .title .sub{
   font-size: 1.46vw;
   letter-spacing:0.3vw;
   font-family:SourceHanSansCN-Medium;
   font-weight: Medium;
 }

</style>
